import React from 'react';
import { useSelector } from 'react-redux';
import { bool, exact, string, arrayOf, number, func } from 'prop-types';
import { Typography, Flex, Button } from '@mixins';
import { theme } from '@styles';
import { TextInput } from '@atoms/Input';
import { Icon } from '@atoms';
import { DataTable } from '@organisms';

import { ReactComponent as Search } from '@assets/svgs/Search.svg';

import { columns } from './columns';

const TeamMembersManagement = ({
  page,
  onPageChange,
  search,
  onSearch,
  companyMembers,
  pagination,
  companyName,
  companyStatus,
  activeMembers,
  onAddUser,
  onUserClick,
  onSortModelChange,
  withBorders,
  withPagination,
}) => {
  const {
    user: { id: userId },
  } = useSelector(store => store.userStore);

  return (
    <>
      <Flex mb="16px" justifyContent="space-between">
        <Typography fontSize={[14, 16, 18]}>
          {activeMembers} Active Team Members at {companyName}
        </Typography>
        <Button
          alignSelf="start"
          backgroundColor={theme.color.mintMinded[300]}
          color={theme.color.mintMinded[900]}
          py={['4px', '6px', '6px']}
          px={['8px', '12px', '12px']}
          fontSize={[10, 12, 14]}
          onClick={onAddUser}>
          + Add Team Member
        </Button>
      </Flex>
      <Flex mb="20px" maxWidth="400px">
        <TextInput value={search} onChange={onSearch} isRound placeholder="Search with name, email or phone...">
          <Icon mr={[10, 12]} SVG={Search} />
        </TextInput>
      </Flex>
      <DataTable
        withBorders={withBorders}
        withPagination={withPagination}
        columnVisibilityModel={{
          status: companyStatus === 'active',
        }}
        sortingMode="server"
        onSortModelChange={onSortModelChange}
        rows={companyMembers}
        columns={columns(userId)}
        onRowClick={onUserClick}
        paginationMode="server"
        paginationModel={{
          pageSize: 8,
          page: page - 1,
        }}
        rowCount={pagination?.total}
        onPaginationModelChange={onPageChange}
      />
    </>
  );
};

TeamMembersManagement.propTypes = {
  withBorders: bool,
  withPagination: bool,
  page: number.isRequired,
  onPageChange: func.isRequired,
  search: string.isRequired,
  onSearch: func.isRequired,
  onSortModelChange: func.isRequired,
  onUserClick: func.isRequired,
  onAddUser: func.isRequired,
  activeMembers: number,
  companyStatus: string.isRequired,
  companyName: string,
  companyMembers: arrayOf(
    exact({
      id: number,
      imageUrl: string,
      email: string,
      firstName: string,
      lastName: string,
      isCompanyAdmin: bool,
      phone: string,
      status: string,
      isAbleToBookMeetingRoom: bool,
      isAbleToInvoice: bool,
      isAbleToPayByCard: bool,
    }),
  ).isRequired,
  pagination: exact({
    pageSize: number,
    page: number,
    cursor: number,
    total: number,
  }).isRequired,
};

TeamMembersManagement.defaultProps = {
  withBorders: true,
  withPagination: true,
  activeMembers: 0,
  companyName: null,
};

export default TeamMembersManagement;
